var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8608 4.63915L8 9.5L3.13915 4.63915C2.65056 4.15056 1.85503 3.87785 1.36644 4.36644C0.877852 4.85503 0.877852 5.6443 1.36644 6.13289L7.11678 11.8832C7.60537 12.3718 8.39463 12.3718 8.88322 11.8832L14.6336 6.13289C15.1221 5.6443 15.1221 4.85503 14.6336 4.36644C14.145 3.89038 13.3494 4.15056 12.8608 4.63915Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7154c4ca77ae140c2f2b9a5b7ebce039.svg";
export { ForwardRef as ReactComponent };